import { render, staticRenderFns } from "./FinanceBottomArea.vue?vue&type=template&id=ba94fd08&scoped=true&"
import script from "./FinanceBottomArea.vue?vue&type=script&lang=js&"
export * from "./FinanceBottomArea.vue?vue&type=script&lang=js&"
import style0 from "./FinanceBottomArea.vue?vue&type=style&index=0&id=ba94fd08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba94fd08",
  null
  
)

export default component.exports